import {get, writable} from 'svelte/store'
import {PLAYER_STATE} from "./chess-console-app/ChessConsoleAppState.js"
import {ChessConsoleApp} from "./chess-console-app/ChessConsoleApp.js"

export const sessionData = writable({
    // configuration
    wsEndpoint: process.env.BASE_GAMBIT_WS,
    // app data
    user: null,
    sumsubHidden: true,
    localSumsubApproval: false,
    sumsubApplication: {},
    token: null,
    recent_payment: false,
    captcha: 'uninitiated',
    payment_failed: false,
    geoCountry: "",
    geoFailed: false,
    sumsubContinue: false,
    hasGeolocated: true,
    sauth: null,
    recent_victory: false,
    recent_defeat: false,
    puzzleCredits: 10,
    puzzleRating: null,
    serverError: null,
    handleCardRender: true,
    inspectBoard: false,
    sidebar: false,
    sidebar: false,
    guser: {current_balance: null},
    balance: 0,
    game: {
        tc: "",
        stk: 1,
    },
    confirmation: null,
    recap: null,
    sumsubActive: false,
    signin_flow: "login",
    isAuthenticating: false,
    signin_user: {
        displayName: "",
        dob: "",
        email: "",
        state: "",
    },
    playerState: PLAYER_STATE.idle, // USE THIS TO HANDLE THE DISPLAYED, for the above deprecated values
    stake: undefined,
    timeControl: undefined,
    selectedCard: undefined,
    stakeModal: false,
    cardLocked: false,
    // GamePage UI
    lookingForOpponent: true, // show the "looking for opponent" screen
    endOfGame: false, // show the end of game modal
    showResignDialog: false, // show the confirm resign dialog
    showAcceptDrawDialog: false, // show the "accept draw" dialog
    showAcceptRematchDialog: false, // show the rematch request dialog in the end of game modal
    // the es6 app
    chessConsoleApp: undefined, // will be dynamically created, if a match starts
    debug: false,
    // game data output
    opponentName: "",
    opponentRating: "----",
    opponentClock: "--:--",
    playerName: "",
    playerRating: "----",
    playerClock: "--:--", // playerClock: "--<span class='active'>:</span>--",
    timeControlMinutes: "-",
    timeControlIncrementSeconds: "-",
    history: "",
    // end of game output
    resultForPlayer: "--",
    endOfGameMessage: "--",
    ratingBefore: "----",
    balanceBefore: "--",
    ratingDiff: "--",
    balanceDiff: "--",
    ratingAfter: "----",
    balanceAfter: "--"
})
